// extracted by mini-css-extract-plugin
module.exports = {"header":"_3qSCn__header","presentation-slides":"_1HKIw__presentation-slides","presentationSlides":"_1HKIw__presentation-slides","videoWrapper":"_1ddZX__videoWrapper"};